import React from "react";
import { Text } from "components/Typography/text.styled";
import { Color } from "config/colors";
import { useTranslation } from "react-i18next";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";

type CreditStatusProps = {
  status: string;
};

const getStatusTranslation = (t: any, status: string): string => {
  const map: Record<string, string> = {
    Created: t("TipCredit.Created"),
    Approved: t("TipCredit.Approved"),
    Failed: t("TipCredit.Failed"),
    Cancelled: t("TipCredit.Cancelled"),
    Paid: t("TipCredit.Paid"),
  };
  return map[status] || status;
};

const getStatusIcon = (status: string) => {
  switch (status) {
    case "Approved":
    case "Paid":
      return (
        <CheckCircleIcon
          fontSize="small"
          style={{ color: Color.ModernGreen, marginRight: "6px" }}
        />
      );
    case "Failed":
      return (
        <ErrorOutlineIcon
          fontSize="small"
          style={{ color: Color.Destructive, marginRight: "6px" }}
        />
      );
    case "Cancelled":
      return (
        <CancelIcon
          fontSize="small"
          style={{ color: Color.SeaBlue600, marginRight: "6px" }}
        />
      );
    default:
      return (
        <HourglassEmptyIcon
          fontSize="small"
          style={{ color: "#999", marginRight: "6px" }}
        />
      );
  }
};

const getStatusStyle = (status: string) => {
  switch (status) {
    case "Approved":
    case "Paid":
      return { color: Color.ModernGreen, margin: 0 };
    case "Failed":
      return { color: Color.Destructive, margin: 0 };
    case "Cancelled":
      return { color: Color.SeaBlue600, margin: 0 };
    default:
      return { color: Color.MidnightBlue, margin: 0 };
  }
};

export const CreditStatus: React.FC<CreditStatusProps> = ({ status }) => {
  const { t } = useTranslation();

  return (
    <div style={{ display: "flex", alignItems: "flex-start" }}>
      {getStatusIcon(status)}
      <Text style={getStatusStyle(status)}>
        {getStatusTranslation(t, status)}
      </Text>
    </div>
  );
};
